import React, { useEffect, useRef, useState } from "react";
import "./RamlCircle.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ramlKey } from "../../data";
// import Header from '../../components/header/Header'
import HeaderB from "../../components/headerb/HeaderB";
import { Link } from "react-router-dom";
import RamlCircle1 from "./RamlCircle1";
import RamlCircle2 from "./RamlCircle2";
import CircleBtn from "./CircleBtn";

export default function RamlCircle() {
  // const imageRef = useRef();
  // const imageSpan1 = useRef();

  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <Row>
          <Col xs={11} md={6}>
            <RamlCircle1
            //  imageRef={imageRef} imageSpan1={imageSpan1}
            />
          </Col>

          <Col xs={12} md={2}>
            {" "}
          </Col>

          <Col xs={8} md={4} center>
            <CircleBtn
            //  imageRef={imageRef} imageSpan1={imageSpan1}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}
